import React from "react";
import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";

const SeoFields = ({ metaTitle, metaDescription, onChange, className = "" }) => (
  <section className={`rounded-xl border border-slate-200 bg-slate-50/70 p-5 ${className}`}>
    <div className="mb-4">
      <h2 className="text-base font-bold text-slate-900">Search metadata</h2>
      <p className="mt-1 text-xs text-slate-500">
        These are the only two SEO fields used for this detail page. Leave either field blank to use the page's automatic fallback.
      </p>
    </div>
    <div className="grid gap-4 lg:grid-cols-2">
      <div className="space-y-2">
        <div className="flex items-center justify-between gap-3">
          <label className="text-sm font-semibold text-slate-700">Meta Title</label>
          <span className="text-xs text-slate-400">{metaTitle.length}/255</span>
        </div>
        <Input
          value={metaTitle}
          onChange={(event) => onChange("meta_title", event.target.value)}
          maxLength={255}
          placeholder="Page title shown in search results"
          className="rounded-lg"
        />
      </div>
      <div className="space-y-2">
        <div className="flex items-center justify-between gap-3">
          <label className="text-sm font-semibold text-slate-700">Meta Description</label>
          <span className="text-xs text-slate-400">{metaDescription.length}/1000</span>
        </div>
        <Textarea
          value={metaDescription}
          onChange={(event) => onChange("meta_description", event.target.value)}
          maxLength={1000}
          rows={3}
          placeholder="Short description shown in search results"
          className="min-h-[92px] rounded-lg"
        />
      </div>
    </div>
  </section>
);

export default SeoFields;
